export default (theme) => ({
  container: {
    padding: 5,
  },
  chip: {
    height: 24,
    fontWeight: 600,
    color: theme.palette.text.default,
    border: `solid 1px ${theme.palette.text.default}`,
    backgroundColor: theme.palette.background.paper,
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: "none",
    },
  },
  emptyChip: {
    height: 24,
    fontWeight: 600,
    color: theme.palette.text.default,
    border: `solid 1px ${theme.palette.text.default}`,
    backgroundColor:
      theme.palette.type === "dark"
        ? theme.palette.background.default
        : "#f5f5f5",
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: "none",
    },
  },
});
